import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import {
  selectFilteredVirtualCards,
  selectVirtualCardsFullPaginatedData,
} from 'src/app/AccountsRequests/redux/accountsRequests.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import PendingRequestsBox from 'src/components/PendingRequestsBox/PendingRequestsBox'
import { VirtualCardsFiltersBody } from 'src/components/VirtualCardsBoxAndLinks/VirtualCardsBoxAndLinks'
import { useBackgroundDispatch } from 'src/hooks'
import { useQueryStatistics } from 'src/queries/statistics/statistics.queries'
import { StatisticsKeys } from 'src/queries/statistics/statistics.queries.constants'
import { getVirtualCards } from 'src/redux/actions/data/virtualCards.actions'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const AccountsRequests: React.FC = () => {
  const virtualCardsFullPaginatedData = useSelector(
    selectVirtualCardsFullPaginatedData,
  )
  const filteredVirtualCards = useSelector(selectFilteredVirtualCards)
  const appName = useSelector(selectAppName)
  const dispatch = useBackgroundDispatch()

  const { results: statisticsResults } = useQueryStatistics({
    statisticsKeys: [
      StatisticsKeys.VirtualCardsPendingRequestCardholderMeCount,
    ] as const,
  })
  const virtualCardsPendingRequestCardholderMeCount =
    statisticsResults[StatisticsKeys.VirtualCardsPendingRequestCardholderMeCount]
      .data ?? 0

  const fetchVirtualCards = (
    filtersBody: VirtualCardsFiltersBody,
    page?: number,
  ): void => {
    dispatch(
      getVirtualCards({
        count: 10,
        page: page,
        cardholder: 'me',
        pendingRequest: true,
        ...filtersBody,
      }),
    )
  }

  const infiniteScrollProps = {
    ...virtualCardsFullPaginatedData,
    fetch: fetchVirtualCards,
  }

  return (
    <>
      <Helmet>
        <title>{`Requests | ${appName}`}</title>
        <meta name="description" content={`Requests page of ${appName}`} />
      </Helmet>
      <BackgroundPageContent>
        <PendingRequestsBox
          virtualCards={filteredVirtualCards}
          infiniteScrollProps={infiniteScrollProps}
          cardApprovalRulesFetched
          showLoadingPage={
            !statisticsResults[
              StatisticsKeys.VirtualCardsPendingRequestCardholderMeCount
            ].isSuccess
          }
          totalCount={virtualCardsPendingRequestCardholderMeCount}
        />
      </BackgroundPageContent>
    </>
  )
}

export default AccountsRequests
